import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PcmpDisburseVerifyPage } from '@/features/pcmp/pages/PcmpDisburseVerifyPage';
import { pcmpDisburseVerifySearchSchema } from '@/features/pcmp/types/pcmpDisburseVerify.types';

export const Route = createFileRoute('/_auth/pcmp/disburse-verify/')({
  validateSearch: pcmpDisburseVerifySearchSchema,
  component: () => (
    <ErrorBoundary moduleName="PCMP Disburse Verify">
      <Suspense fallback={<PageLoader />}>
        <PcmpDisburseVerifyPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
